export default [
  {
    path: '/holiday',
    name: 'list-holiday',
    component: () => import('@/views/holiday/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.holiday',
      resource: 'manage-holiday',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.list_holiday',
          active: true,
        },
      ],
    },
  },
  {
    path: '/holiday/create',
    name: 'create-holiday',
    component: () => import('@/views/holiday/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.holiday',
      navActiveLink: 'list-holiday',
      resource: 'manage-holiday',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.list_holiday',
          to: { name: 'list-list_holiday' }
        },
        {
          text: 'breadcrumb.create_holiday',
          active: true,
        },
      ],
    },
  },
  {
    path: '/holiday/:id/update',
    name: 'update-holiday',
    component: () => import('@/views/holiday/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.holiday',
      navActiveLink: 'list-holiday',
      resource: 'manage-holiday',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.list_holiday',
          to: { name: 'list-holiday' }
        },
        {
          text: 'breadcrumb.update_holiday',
          active: true,
        },
      ],
    },
  },
]
